import { defineStore, acceptHMRUpdate } from 'pinia';

const store = defineStore('eventbus', {
  state: () => ({
    events: {
      // eventName : { listenerName1: callback1, listenerName2: callback2, ... }

      // List of events in Planning
      'project-updated': { 'element-details': null, 'macro-element-details': null }, // called in Planning.vue
      'update-project': { planning: null }, // called in store/planning/planning.js

      // List of events in Manage
      'update-project-tabs': { 'manage-projects': null }, // called in ManageUsersUserAcr.vue
      'update-user-tabs': { 'manage-users': null }, // called in ManageProjectsProjectAcr.vue + ManageUsersUserAcr.vue
    },
  }),

  actions: {
    register({ event, listener, cb }) {
      if (! listener || ! Object.keys(this.events[event] || {}).includes(listener)) {
        console.error('invalid event or listener', event, listener);
        return;
      }
      this.events[event][listener] = cb;
    },
    remove({ event, listener } = {}) {
      const events = event ? [event] : Object.keys(this.events);
      events.forEach((eventName) => {
        const listeners = listener ? [listener] : Object.keys(this.events[eventName]);
        listeners.forEach((listenerData) => {
          if (this.events[eventName][listenerData]) this.events[eventName][listenerData] = null;
        });
      });
    },
    call({ event, param }) {
      if (! this.events[event]) {
        console.error('invalid event', event);
        return;
      }
      Object.keys(this.events[event]).forEach((listener) => {
        if (this.events[event][listener]) this.events[event][listener](param);
      });
    },
  },
});

export default store;

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
}
